// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@eisinc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 24px 135px;
        & > div {
            padding-right: 2px;
            &:empty {
                display: none;
            }
        }
        ${xScreen("lt", "lg")} {
            grid-template-columns: 1fr;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentDetailsHeading = {
    variant: "h4",
    css: css`
        margin-bottom: 12px;
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.poNumberGridItem = {
    width: 6,
    css: css`
        ${xScreen("lte", "md")} {
            order: 3;
        }
    `,
};
